var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("개인정보 처리 방침")]),_c('div',{staticClass:"text-wrap"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.privacy.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }